import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-square",
  templateUrl: "./med-icon-square.component.html",
})
export class MedIconSquareComponent extends SvgMixinComponent {}
